import { capitalize } from 'vue'

export function getUserInitials(displayName: string) {
  const nameParts = displayName.split(' ')

  if (nameParts.length === 1) {
    const name = nameParts[0]
    return capitalize(name.substring(0, 2))
  }

  return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase()
}
